import { actions, reducers } from './Approvals.redux';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';
import { registerNavigation } from "@/core/navigation";
import { registerNotificationHandler } from "@/core/notificationHandler";
import React, { lazy } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import {
	actions as approvalsReviewActions,
	reducers as approvalsReviewReducers,
} from './ApprovalsReview/ApprovalsReview.redux';
import ApprovalNotificationHandler from './Approvals.notificationHandler';



const Approvals       = lazy(() => import('./Approvals')),
	  ApprovalsReview = lazy(() => import('./ApprovalsReview'));

registerReduxStore('approvals', reducers, actions);
registerReduxStore('approvalsReview', approvalsReviewReducers, approvalsReviewActions);


registerRoutes([
	{
		path: '/approvals/:mode?',
		exact: true,
		render: <Approvals />,
		title: 'Approvals',
		private: true,
		permissions: [ 'approvals' ],
	},

	{
		path: '/approvals-review',
		exact: true,
		render: <ApprovalsReview />,
		title: 'Approvals Review',
		private: true,
		permissions: [ 'approvals' ],
	},
]);

registerNavigation({
	title: 'Approvals',
	permissions: [ 'approvals' ],
	single: false,
	top: true,
	home: true,
	icon: <CheckCircleOutlined />,
	children: [
		{
			title: 'Open',
			url: '/approvals/open',
			permissions: [ 'approvals' ],
		},
		{
			title: 'Approved',
			url: '/approvals/approved',
			permissions: [ 'approvals' ],
		},
		{
			title: 'Rejected',
			url: '/approvals/rejected',
			permissions: [ 'approvals' ],
		},
		{
			title: 'Review',
			url: '/approvals-review',
			permissions: [ 'approvals' ],
		},
	],
});


registerNotificationHandler('approval', (metadata, setChild) => {
	setChild(<ApprovalNotificationHandler metadata={metadata} handleClose={() => setChild(null)} />);
});


console.log('Registered Approvals Plugin');